import { SetStateAction, useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { withMask } from 'use-mask-input';
import { Button } from '../../../../../../component';
import {
  labelFormatterMoneyAsInteger,
  unmaskAbsoluteValue,
} from '../../../../../../shared/formatters/formatters';
import nls from '../../../nls/pt-BR.json';
import '../studyCreationGuide.scss';
import {
  EditLayoutValuation,
  EditLayoutValuationFormData,
} from './layoutsValuation';

interface EditValuationProps {
  valuationIndex: number;
  setEditMode: React.Dispatch<SetStateAction<boolean[]>>;
  editMode: boolean[];
  valuation: EditLayoutValuation;
}

export const EditValuation: React.FC<EditValuationProps> = ({
  valuationIndex,
  setEditMode,
  editMode,
  valuation,
}) => {
  const {
    formState: { errors },
    setValue,
  } = useFormContext<EditLayoutValuationFormData>();
  const [pricePerUnit, setPricePerUnit] = useState<string>(
    valuation.pricePerUnit
  );
  const [pricePerSqMt, setPricePerSqMt] = useState<string>(
    valuation.pricePerSqMt
  );
  const handleClickConfirm = () => {
    setValue(`layouts.${valuationIndex}.pricePerSqMt`, pricePerSqMt);
    setValue(`layouts.${valuationIndex}.pricePerUnit`, pricePerUnit);
    setValue(`layouts.${valuationIndex}.isEdited`, true);
    const newEditMode = editMode.map((el, index) =>
      index === valuationIndex ? false : el
    );
    setEditMode(newEditMode);
  };
  const handleClickExit = () => {
    const newEditMode = editMode.map((el, index) =>
      index === valuationIndex ? false : el
    );
    setEditMode(newEditMode);
  };
  const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    const newPricePerUnit = e.currentTarget.value.replaceAll('_', '');
    setPricePerUnit(newPricePerUnit);
    const unmaskedPricePerUnit = unmaskAbsoluteValue(
      newPricePerUnit.split('R$')[1]
    );
    const newPricePerSqMt = unmaskedPricePerUnit / valuation.area;
    const formattedNewPricePerSqMt =
      labelFormatterMoneyAsInteger(newPricePerSqMt);
    if (Number.isNaN(newPricePerSqMt)) {
      setPricePerSqMt('R$ 00');
      return;
    }
    setPricePerSqMt(formattedNewPricePerSqMt);
  };
  return (
    <div className="edit-valuation">
      <div className="row-container-space-between">
        <h6 className="layout-number">{nls.editValuation.editValue}</h6>
        <Button
          cy="CloseEditValuation"
          type="link"
          style={{ color: '#A2A4A4' }}
          onClick={handleClickExit}
        >
          X
        </Button>
      </div>
      <div className="grid-container">
        <label htmlFor={`price-per-unit[${valuationIndex}]`}>
          {nls.editValuation.unitValue}
        </label>
        <p>{nls.editValuation.pricePerSqMt}</p>
        <input
          id={`price-per-unit[${valuationIndex}]`}
          placeholder="R$ 00"
          style={{ width: '100%' }}
          className="default-input"
          type="text"
          ref={withMask([
            'R$ 999',
            'R$ 9.999',
            'R$ 99.999',
            'R$ 999.999',
            'R$ 9.999.999',
            'R$ 99.999.999',
            'R$ 999.999.999',
          ])}
          onChange={handleChange}
          value={pricePerUnit}
        />
        <p style={{ fontWeight: 700, margin: '4px 0px 15px 0px' }}>
          {pricePerSqMt}
        </p>
      </div>
      <Button
        cy="ConfirmEdit"
        onClick={handleClickConfirm}
        type="btn"
        className="btn normal confirm-button"
      >
        {nls.editValuation.confirm}
      </Button>
    </div>
  );
};
